<template>
    <div v-if="workspaceInvitationModel" class="container">
        <br /><br />
        <div class="jumbotron">
            <h1 class="display-4">Invitation to workspace {{workspaceName}}</h1>
            <p class="lead">You were invited to workspace <strong>{{workspaceName}}</strong> owned by <strong>{{organizationName}}</strong> in TransparentChoice application</p>
            <hr>

            <button @click="handleAcceptWorkspaceInvitationCommandV1" class="btn btn-success text-white" style="padding: 0.7em 2em;">
                <i class="fa fa-check" aria-hidden="true"></i>
                <span>Accept invitation</span>
            </button>

            <button @click="handleRejectWorkspaceInvitationCommandV1" class="btn btn-secondary text-white" style="padding: 0.7em 2em;">
                <i class="fa fa-ban" aria-hidden="true"></i>
                <span>Reject invitation</span>
            </button>
        </div>
    </div>

    <div v-else>
        <h4>Loading...</h4>
    </div>
</template>

<script lang="ts">
    import Component, { mixins } from 'vue-class-component';
    import PageBase from "@common/PageBase";
    import PageStatus from "@common/PageStatus";
    import Queries from "@Organizations/Workspaces/Domain/queries-vue-component";
    import Commands from "@Organizations/Workspaces/Domain/commands-vue-component";

    @Component
    export default class CreateUserPage extends mixins(PageBase, PageStatus, Queries, Commands) {

        get workspaceInvitationModel() { return this.model?.WorkspaceInvitation; }
        get workspaceId() { return this.workspaceInvitationModel?.WorkspaceId; }
        get workspaceName() { return this.workspaceInvitationModel?.WorkspaceName; }
        get organizationName() { return this.workspaceInvitationModel?.OrganizationName; }
        get recipientEmail() { return this.workspaceInvitationModel?.RecipientEmail; }

        mounted() {
            this.setTitle('Invitation to workspace ' + this.workspaceName);
            const token = this.$route.params.token;
            this.runWorkspaceInvitationQueryV1(token);
        }

        succeedAnyCommand(status) {
            this.navigateTo('/#/organizations/users/dashboard')
        }

        handleAcceptWorkspaceInvitationCommandV1() {
            this.invokeAcceptWorkspaceInvitationCommandV1(this.workspaceId, this.recipientEmail);
        }

        handleRejectWorkspaceInvitationCommandV1() {
            this.invokeRejectWorkspaceInvitationCommandV1(this.workspaceId, this.recipientEmail);
        }
    }
</script>

<style scoped>
</style>